module.exports = {
  home: {
    title: "Get Started Today | Cove",
    description:
      "Cove makes it easy to consult with a licensed doctor and get the migraine medication you need directly delivered to your door.",
    "og:title": "Get Started Today | Cove",
    "og:description":
      "Cove makes it easy to consult with a licensed doctor and get the migraine medication you need directly delivered to your door."
  }
}
